// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var ListType$ReactHooksTemplate = require("../data_fields/listType.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");

var AnswerNotFound = /* @__PURE__ */Caml_exceptions.create("ListCondition-ReactHooksTemplate.AnswerNotFound");

var sentimentGroupId = "sentiment";

function lhs(t) {
  return t.lhs;
}

function operator(t) {
  return t.operator;
}

function rhs(t) {
  return t.rhs;
}

function groupId(t) {
  return t.groupId;
}

function setLhs(t, lhs) {
  return {
          lhs: lhs,
          operator: t.operator,
          rhs: t.rhs,
          groupId: t.groupId
        };
}

function setOperator(t, operator) {
  return {
          lhs: t.lhs,
          operator: operator,
          rhs: t.rhs,
          groupId: t.groupId
        };
}

function setRhs(t, rhs) {
  return {
          lhs: t.lhs,
          operator: t.operator,
          rhs: rhs,
          groupId: t.groupId
        };
}

function setGroupId(t, groupId) {
  return {
          lhs: t.lhs,
          operator: t.operator,
          rhs: t.rhs,
          groupId: groupId
        };
}

function isSentimentCondition(t) {
  return Caml_obj.equal(t.groupId, sentimentGroupId);
}

var sentimentAnswerList = {
  hd: [
    "positive",
    "Positive"
  ],
  tl: {
    hd: [
      "negative",
      "Negative"
    ],
    tl: {
      hd: [
        "neutral",
        "Neutral"
      ],
      tl: {
        hd: [
          "na",
          "Not Applicable"
        ],
        tl: /* [] */0
      }
    }
  }
};

function multipleAnswerEnabled(lhs) {
  if (lhs.TAG !== "Question") {
    return true;
  }
  var multipleSelect = lhs._0.questionType;
  if (multipleSelect.TAG === "MultipleSelect") {
    return MultipleSelect$ReactHooksTemplate.multipleAnswer(multipleSelect._0);
  } else {
    return false;
  }
}

function availableOperators(lhs, groupId) {
  if (groupId !== undefined && groupId === sentimentGroupId) {
    return {
            hd: "is_any_of",
            tl: {
              hd: "not_any_of",
              tl: {
                hd: "is_blank",
                tl: {
                  hd: "is_not_blank",
                  tl: /* [] */0
                }
              }
            }
          };
  }
  if (multipleAnswerEnabled(lhs)) {
    return {
            hd: "equals",
            tl: {
              hd: "is_any_of",
              tl: {
                hd: "not_any_of",
                tl: {
                  hd: "is_every_of",
                  tl: {
                    hd: "is_blank",
                    tl: {
                      hd: "is_not_blank",
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          };
  } else {
    return {
            hd: "equals",
            tl: {
              hd: "is_any_of",
              tl: {
                hd: "not_any_of",
                tl: {
                  hd: "is_blank",
                  tl: {
                    hd: "is_not_blank",
                    tl: /* [] */0
                  }
                }
              }
            }
          };
  }
}

function availableOperatorsForCondition(t) {
  return availableOperators(t.lhs, t.groupId);
}

function humanizeOperator(text, t) {
  switch (text) {
    case "equals" :
        return "Equals";
    case "is_any_of" :
        return "Is Any Of";
    case "is_blank" :
        var match = t.lhs;
        if (match.TAG === "Question") {
          return "Is Not Answered";
        } else {
          return "Is Blank";
        }
    case "is_every_of" :
        return "Is Every of";
    case "is_not_blank" :
        var match$1 = t.lhs;
        if (match$1.TAG === "Question") {
          return "Is Answered";
        } else {
          return "Is Not Blank";
        }
    case "not_any_of" :
        return "Not Any Of";
    default:
      return "";
  }
}

function answerListForCondition(t) {
  var lhs = t.lhs;
  var groupId = t.groupId;
  if (groupId !== undefined && groupId === sentimentGroupId) {
    return sentimentAnswerList;
  }
  if (lhs.TAG === "Question") {
    var dropDown = lhs._0.questionType;
    switch (dropDown.TAG) {
      case "MultipleChoice" :
          return MultipleChoice$ReactHooksTemplate.choices(dropDown._0);
      case "MultipleSelect" :
          var multipleSelect = dropDown._0;
          console.log(MultipleSelect$ReactHooksTemplate.answerList(multipleSelect));
          return MultipleSelect$ReactHooksTemplate.answerList(multipleSelect);
      case "DropDown" :
          return DropDown$ReactHooksTemplate.answerList(dropDown._0);
      default:
        return /* [] */0;
    }
  } else {
    var listType = DataField$ReactHooksTemplate.dataType(lhs._0);
    if (listType.TAG === "ListType") {
      return List.mapi((function (i, x) {
                    return [
                            String(i),
                            x
                          ];
                  }), ListType$ReactHooksTemplate.options(listType._0));
    } else {
      return /* [] */0;
    }
  }
}

function getAnswer(question) {
  var multipleSelect = question.questionType;
  switch (multipleSelect.TAG) {
    case "MultipleChoice" :
        return MultipleChoice$ReactHooksTemplate.answerIdList(multipleSelect._0);
    case "MultipleSelect" :
        return MultipleSelect$ReactHooksTemplate.answerIdList(multipleSelect._0);
    case "DropDown" :
        return DropDown$ReactHooksTemplate.answerIdList(multipleSelect._0);
    default:
      return ;
  }
}

function getValue(dataField) {
  var listType = DataField$ReactHooksTemplate.dataType(dataField);
  if (listType.TAG === "ListType") {
    return ListType$ReactHooksTemplate.value(listType._0);
  }
  
}

function evalNonBlankCase(answerSet, rhsIdSet, t) {
  var match = t.operator;
  switch (match) {
    case "equals" :
        return Belt_SetString.eq(answerSet, rhsIdSet);
    case "is_any_of" :
        return !Belt_SetString.isEmpty(Belt_SetString.intersect(answerSet, rhsIdSet));
    case "is_every_of" :
        return Belt_SetString.eq(Belt_SetString.intersect(answerSet, rhsIdSet), rhsIdSet);
    case "not_any_of" :
        return Belt_SetString.isEmpty(Belt_SetString.intersect(answerSet, rhsIdSet));
    default:
      return false;
  }
}

function evalBlankCase(t) {
  var match = t.operator;
  switch (match) {
    case "is_blank" :
    case "not_any_of" :
        return true;
    default:
      return false;
  }
}

function evaluate(t) {
  var rhs = t.rhs;
  var rhsIdSet = rhs !== undefined ? Belt_SetString.fromArray(Belt_List.toArray(List.map((function (x) {
                    return x[0];
                  }), rhs))) : undefined;
  var question = t.lhs;
  if (question.TAG === "Question") {
    var question$1 = question._0;
    if (!Question$ReactHooksTemplate.answered(question$1)) {
      return evalBlankCase(t);
    }
    var match = t.operator;
    switch (match) {
      case "is_blank" :
          return false;
      case "is_not_blank" :
          return true;
      default:
        var xs = getAnswer(question$1);
        if (xs !== undefined) {
          var answerSet = Belt_SetString.fromArray(Belt_List.toArray(xs));
          return evalNonBlankCase(answerSet, rhsIdSet, t);
        }
        throw {
              RE_EXN_ID: AnswerNotFound,
              _1: "The Answer Not Found",
              Error: new Error()
            };
    }
  } else {
    var value = getValue(question._0);
    var match$1 = t.operator;
    switch (match$1) {
      case "is_blank" :
          return value === undefined;
      case "is_not_blank" :
          return value !== undefined;
      default:
        if (value === undefined) {
          return evalBlankCase(t);
        }
        var answerSet$1 = Belt_SetString.fromArray(Belt_List.toArray(value));
        return evalNonBlankCase(answerSet$1, rhsIdSet, t);
    }
  }
}

function placeholderQuestion(lhsId) {
  return {
          mandatory: false,
          questionType: {
            TAG: "LongText",
            _0: LongText$ReactHooksTemplate.empty()
          },
          id: lhsId,
          position: undefined
        };
}

function decodeLhs(json, questions, dataFields) {
  var lhsId = Json_decode.field("lhs_id", Json_decode.$$int, json);
  var lhsType = Json_decode.field("lhs_type", Json_decode.string, json);
  switch (lhsType) {
    case "DataField" :
        var df = Belt_List.getBy(dataFields, (function (df) {
                return Caml_obj.equal(DataField$ReactHooksTemplate.id(df), lhsId);
              }));
        if (df !== undefined) {
          return {
                  TAG: "DataField",
                  _0: Caml_option.valFromOption(df)
                };
        } else {
          return {
                  TAG: "DataField",
                  _0: DataField$ReactHooksTemplate.placeholder(lhsId)
                };
        }
    case "Question" :
        var q = Belt_List.getBy(questions, (function (q) {
                return Caml_obj.equal(Question$ReactHooksTemplate.id(q), lhsId);
              }));
        if (q !== undefined) {
          return {
                  TAG: "Question",
                  _0: q
                };
        } else {
          return {
                  TAG: "Question",
                  _0: placeholderQuestion(lhsId)
                };
        }
    default:
      return Js_exn.raiseError("Unknown lhs type");
  }
}

function decodeRhs(lhs, groupId, json) {
  var rhsIds = Json_decode.field("rhs", (function (param) {
          return Json_decode.optional((function (param) {
                        return Json_decode.list(Json_decode.string, param);
                      }), param);
        }), json);
  if (groupId !== undefined) {
    if (rhsIds === undefined) {
      return /* [] */0;
    }
    if (groupId === sentimentGroupId) {
      return Belt_List.map(rhsIds, (function (value) {
                    var pair = Belt_List.getBy(sentimentAnswerList, (function (param) {
                            return param[0] === value;
                          }));
                    if (pair !== undefined) {
                      return pair;
                    } else {
                      return [
                              value,
                              value
                            ];
                    }
                  }));
    }
    
  }
  if (rhsIds !== undefined) {
    return Belt_List.map(rhsIds, (function (x) {
                  if (lhs.TAG === "Question") {
                    var y = Question$ReactHooksTemplate.questionType(lhs._0);
                    switch (y.TAG) {
                      case "MultipleChoice" :
                          return List.find((function (param) {
                                        return param[0] === x;
                                      }), MultipleChoice$ReactHooksTemplate.choices(y._0));
                      case "MultipleSelect" :
                          return List.find((function (param) {
                                        return param[0] === x;
                                      }), Belt_List.map(MultipleSelect$ReactHooksTemplate.choices(y._0), (function (choice) {
                                            return [
                                                    RandomId$ReactHooksTemplate.toString(choice.id),
                                                    choice.text
                                                  ];
                                          })));
                      case "DropDown" :
                          return List.find((function (param) {
                                        return param[0] === x;
                                      }), Belt_List.map(DropDown$ReactHooksTemplate.choices(y._0), (function (choice) {
                                            return [
                                                    RandomId$ReactHooksTemplate.toString(choice.id),
                                                    choice.text
                                                  ];
                                          })));
                      default:
                        return [
                                "",
                                ""
                              ];
                    }
                  } else {
                    var _listType = DataField$ReactHooksTemplate.dataType(lhs._0);
                    if (_listType.TAG === "ListType") {
                      return [
                              x,
                              x
                            ];
                    } else {
                      return [
                              "",
                              ""
                            ];
                    }
                  }
                }));
  } else {
    return /* [] */0;
  }
}

function decode(json, questions, dataFields) {
  var lhs = decodeLhs(json, questions, dataFields);
  var groupId = Json_decode.field("group_id", (function (param) {
          return Json_decode.optional(Json_decode.string, param);
        }), json);
  var rhs = decodeRhs(lhs, groupId, json);
  return {
          lhs: lhs,
          operator: Json_decode.field("operator", Json_decode.string, json),
          rhs: rhs,
          groupId: groupId
        };
}

function choiceIds(t) {
  var match = t.lhs;
  if (match.TAG === "Question") {
    var rhs = t.rhs;
    if (rhs !== undefined) {
      return List.map((function (param) {
                    return param[0];
                  }), rhs);
    } else {
      return /* [] */0;
    }
  }
  var rhs$1 = t.rhs;
  if (rhs$1 !== undefined) {
    return List.map((function (param) {
                  return param[1];
                }), rhs$1);
  } else {
    return /* [] */0;
  }
}

function encodeRhs(t) {
  var choiceIds$1 = choiceIds(t);
  if (choiceIds$1) {
    return Belt_List.toArray(Belt_List.map(choiceIds$1, (function (x) {
                      return x;
                    })));
  } else {
    return null;
  }
}

exports.lhs = lhs;
exports.operator = operator;
exports.rhs = rhs;
exports.setLhs = setLhs;
exports.setOperator = setOperator;
exports.setRhs = setRhs;
exports.groupId = groupId;
exports.setGroupId = setGroupId;
exports.isSentimentCondition = isSentimentCondition;
exports.sentimentGroupId = sentimentGroupId;
exports.sentimentAnswerList = sentimentAnswerList;
exports.multipleAnswerEnabled = multipleAnswerEnabled;
exports.availableOperators = availableOperators;
exports.availableOperatorsForCondition = availableOperatorsForCondition;
exports.answerListForCondition = answerListForCondition;
exports.humanizeOperator = humanizeOperator;
exports.decode = decode;
exports.encodeRhs = encodeRhs;
exports.evaluate = evaluate;
/* DropDown-ReactHooksTemplate Not a pure module */
